module.exports = __webpack_public_path__ + "static/media/electro.36e49722.jpg";